import { render, staticRenderFns } from "./EducationalHistorySection.vue?vue&type=template&id=15f3a28c&scoped=true"
import script from "./EducationalHistorySection.vue?vue&type=script&lang=js"
export * from "./EducationalHistorySection.vue?vue&type=script&lang=js"
import style0 from "./EducationalHistorySection.vue?vue&type=style&index=0&id=15f3a28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3a28c",
  null
  
)

export default component.exports